import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "changePassword";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports

export const changePasswordActions = { ...slice.actions, ...extraActions };
export const changePasswordReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    updatePasswordStatus: null,
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/LoginUser`;

  return {
    updatePassword: updatePassword(),
  };

  //   function updatePassword() {
  //     return createAsyncThunk(
  //       `${name}/UpdatePublicUserPassword`,
  //       async () => await fetchWrapper.get(baseUrl)
  //     );
  //   }

  function updatePassword() {
    return createAsyncThunk(
      `${name}/UpdatePublicUserPassword `,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdatePublicUserPassword`,data
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.updatePassword.pending, (state) => {
      state.updatePasswordStatus = { loading: true };
    })
    .addCase(extraActions.updatePassword.fulfilled, (state, action) => {
      state.updatePasswordStatus = action.payload;
    })
    .addCase(extraActions.updatePassword.rejected, (state, action) => {
      state.updatePasswordStatus = { error: action.error };
    });
}
